import React from 'react';

import OptableMain from '../optable/OptableMain';

import OptOutColumnManager from './OptOutColumnManager';
import OptOutDataModel from './OptOutDataModel';
import OptOutSummaryView from './OptOutSummaryView';

export class OptOutMain extends OptableMain {
  constructor(props) {
    super(props);

    this.dataModel = new OptOutDataModel(
      this.locale,
      this.counterparty,
      this.commandDataModel,
      this.summaryDataModel
    );

    this.columnManager = new OptOutColumnManager(
      this.session,
      this.counterparty
    );
    this.columnManager.settings.loadColumnSettings();
  }

  getDataGridRowClassName() {
    return 'pwx-opt-out-datagrid-row';
  }

  renderUsageSummaries() {
    return (
      <div>
        <OptOutSummaryView
          dataModel={this.summaryDataModel}
          locale={this.locale}
        />
      </div>
    );
  }
}
